<app-lend-pool-details-default *ngIf="(category_id !== 'overdraft') && (category_id !== 'vault')" [pool_id]="pool_id"
    [category_id]="category_id"></app-lend-pool-details-default>

<app-lend-pool-details-vault *ngIf="category_id === 'vault'" [pool_id]="pool_id"
    [category_id]="category_id"></app-lend-pool-details-vault>